<div class="ab-cards">
  <div class="ab-card ab-card--no-border">
    <h1 class="ab-card__data">
      {{ totalDeploys | numberToHuman }}
      <ab-trend
        class="ab-card__trend"
        [countList]="deployCountList"
        [dur]="dur"
        [statType]="'deploys'"
        [neutralStyle]="true"
      ></ab-trend>
    </h1>
    Deploys
  </div>
  <div class="ab-card ab-card--no-border">
    <h1 class="ab-card__data">
      {{ deploysWithErrorsCount | numberToHuman }}
    </h1>
    Deploys with new errors
  </div>
</div>
